var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('document-tab',{on:{"toggle":_vm.toggleTab}}),_c('document-tab-content',{attrs:{"physician":{
                ViewTab: _vm.isViewTabActive,
                UploadTabs: _vm.isUploadTabActive,
                RequestTab: _vm.isRequestTabActive,
            }},on:{"toggle":_vm.toggleTab}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }